export enum SettingKeyEnum {
  Quota = 'quota',
  QuotaState = 'quotaState',
  Threshold = 'threshold',
  ThresholdState = 'tresholdState',
}

export enum SettingStateEnum {
  ENABLED = 'Activé',
  DISABLED = 'Désactivé',
}

export interface SettingsBody {
  quota: { old: number; new: number };
  threshold: { old: number; new: number };
}
